"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("./constants");
var _statefulContainer = _interopRequireDefault(require("./stateful-container"));
var _popover = _interopRequireDefault(require("./popover"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

function StatefulPopover(props) {
  const {
    children,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(_statefulContainer.default, restProps, popoverProps => /*#__PURE__*/React.createElement(_popover.default, popoverProps, children));
}
StatefulPopover.defaultProps = {
  accessibilityType: _constants.ACCESSIBILITY_TYPE.menu,
  ignoreBoundary: false,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: _constants.PLACEMENT.auto,
  showArrow: false,
  triggerType: _constants.TRIGGER_TYPE.click,
  dismissOnClickOutside: true,
  dismissOnEsc: true,
  // @ts-ignore
  stateReducer: (_, nextState) => nextState,
  popoverMargin: _constants.POPOVER_MARGIN
};
var _default = exports.default = StatefulPopover;